import React from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import HrbTranslate from "../language/HrbTranslate";
import './Breadcrumb.scss'

const Breadcrumb = ({ text, onClick, isDisabled, params }) => (
    <div className={classNames("hrb-link", { "hrb-link-disabled": isDisabled === true })} onClick={isDisabled ? () => { } : onClick}>
        <i className="la la-angle-left hrb-breadcrumb" />
        <span className="hrb-breadcrumb-link">
            <HrbTranslate text={text || "common.back"} params={params}/>
        </span>
    </div>
);

Breadcrumb.propTypes = {
    text: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    params: PropTypes.object
};

export default Breadcrumb;